const toolbarMaxHeight = 64

export const useTopBarHeight = () => {
  const topBarHeight = toolbarMaxHeight
  return topBarHeight
}
